import { render, staticRenderFns } from "./VistaNoticias.vue?vue&type=template&id=37b8677e"
import script from "./VistaNoticias.vue?vue&type=script&lang=js"
export * from "./VistaNoticias.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports